import script from "./PresentationView.vue?vue&type=script&setup=true&lang=js"
export * from "./PresentationView.vue?vue&type=script&setup=true&lang=js"

import "./PresentationView.vue?vue&type=style&index=0&id=43be9fde&scoped=true&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43be9fde"]])

export default __exports__